module.exports = __webpack_public_path__ + "static/23-1567bce770f9ff12d24336299c93dee1.png";